export default "__VITE_ASSET__Be84CJ5M__"